import TextControl from './text-control';

export default TextControl;